<template>
	<div class="wrapper">
		<side-bar>
			<sidebar-link to="/dashboard">
				<md-icon>dashboard</md-icon>
				<p>របាយការណ៏</p>
			</sidebar-link>
			<sidebar-link to="/new_loan">
				<md-icon>add_business</md-icon>
				<p>បង្កើតរំលោះថ្មី</p>
			</sidebar-link>
			<sidebar-link to="/loans">
				<md-icon>request_quote</md-icon>
				<p>គ្រប់គ្រងរំលោះ</p>
			</sidebar-link>
			<sidebar-link to="/clients">
				<md-icon>groups</md-icon>
				<p>គ្រប់គ្រងអតិថិជន</p>
			</sidebar-link>
			<sidebar-link to="/projects">
				<md-icon>home_work</md-icon>
				<p>គ្រប់គ្រងគម្រោង</p>
			</sidebar-link>
			<sidebar-link to="/calendar">
				<md-icon>paid</md-icon>
				<p>ការទូទាត់ប្រាក់</p>
			</sidebar-link>
			<sidebar-link to="/transactions">
				<md-icon>history</md-icon>
				<p>ប្រវត្តិប្រតិបត្តិការ</p>
			</sidebar-link>
			<!-- <sidebar-link to="/settings">
				<md-icon>settings</md-icon>
				<p>ការកំណត់ប្រព័ន្ធ</p>
			</sidebar-link> -->
			<sidebar-link to="/administrators" v-if="$store.state.authentication.account_type == 'sa'">
				<md-icon>supervised_user_circle</md-icon>
				<p>ការកំណត់គណនី</p>
			</sidebar-link>
		</side-bar>

		<div class="main-panel">
			<top-navbar></top-navbar>

			<dashboard-content>

			</dashboard-content>

			<content-footer v-if="!$route.meta.hideFooter"></content-footer>
		</div>
	</div>
</template>

<script>
	import TopNavbar from './TopNavbar.vue'
	import ContentFooter from './ContentFooter.vue'
	import DashboardContent from './Content.vue'

	export default {
		components: {
			TopNavbar,
			DashboardContent,
			ContentFooter
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Layout/DashboardLayout.vue